module.exports = __webpack_public_path__ + "static/media/5DPO14.4ab0e0a7.jpg";